import { ISelectOption } from '@/components/form/fields/SelectField';
import React, { useState, Fragment } from 'react';
import {
  Combobox,
  ComboboxButton,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
} from '@headlessui/react';
import { FaAngleDown } from 'react-icons/fa6';

type SelectFieldRowProps = {
  options: ISelectOption[];
  onChange: (value: string) => void;
  value?: string;
  disabled?: boolean;
};

export const SelectFieldRow: React.FC<SelectFieldRowProps> = ({
  options,
  onChange,
  value = '',
  disabled,
}) => {
  const [query, setQuery] = useState('');
  const [selectedValue, setSelectedValue] = useState(value);

  const filteredOptions =
    query === ''
      ? options
      : options.filter(option =>
        option.label
          .toLowerCase()
          .replace(/\s+/g, '')
          .includes(query.toLowerCase().replace(/\s+/g, '')),
      );

  return (
    <Combobox
      as="div"
      value={selectedValue}
      onChange={(value: string) => {
        if (value) {
          setSelectedValue(value);
          setQuery('');
          onChange(value);
        }
      }}
      disabled={disabled}
    >
      <div className="relative">
        <div className="flex">
          <ComboboxInput
            as="input"
            aria-label="Assigned To"
            className="w-full px-2 py-3 border-2"
            displayValue={(value: string) =>
              options.find(option => option.value === value)?.label || query
            }
            onChange={event => {
              setQuery(event.target.value);
            }}
          />
          <ComboboxButton className="px-2 py-2 border-r border-y bg-inherit">
            <FaAngleDown className="text-md" />
          </ComboboxButton>
        </div>

        {filteredOptions.length > 0 ? (
          <ComboboxOptions
            anchor="bottom start"
            className="absolute z-50 py-1 mt-1 overflow-auto text-base bg-white rounded-md shadow-lg max-h-60 w-52 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm"
          >
            {filteredOptions.map(option => (
              <ComboboxOption
                key={option.value}
                value={option.value}
                as={Fragment}
              >
                {({ focus }) => (
                  <div
                    className={`cursor-pointer select-none py-2 px-4 ${focus ? 'bg-blue-600 text-white' : 'text-gray-900'
                      }`}
                  >
                    {option.label}
                  </div>
                )}
              </ComboboxOption>
            ))}
          </ComboboxOptions>
        ) : (
          <div className="absolute z-50 w-full px-4 py-2 mt-1 text-gray-500 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5">
            No options found
          </div>
        )}
      </div>
    </Combobox>
  );
};
